<footer class="app-footer">
  <div class="footer-left">
    <a
      href="https://www.set.or.th/en/privacy-notice"
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Policy
    </a>

    <span class="divider">|</span>

    <a
      href="https://www.set.or.th/en/terms-and-conditions"
      target="_blank"
      rel="noopener noreferrer"
    >
      Terms &amp; Conditions of Use
    </a>
  </div>

  <div class="footer-right">
    © The Stock Exchange of Thailand.
  </div>
</footer>